import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { EditProfile } from 'containers/forms/dashboard'
import { MaterialModal, MaterialControlBar } from 'components/layout'
import { initialValuesEdit } from 'models/profile'

export default class ProfileDetailsModal extends Component {
  static propTypes = {
    profile: PropTypes.object,
    modalId: PropTypes.string,
    isAssessor: PropTypes.bool
  }

  state = {
    isEdit: false
  }

  openEdit = () => this.setState({ isEdit: !this.state.isEdit })
  closeEdit = () => this.setState({ isEdit: false })

  render() {
    const { modalId, profile, isAssessor } = this.props
    const { isEdit } = this.state

    return (
      <MaterialModal.Body
        id={modalId}
        title={`${get(profile, 'data.firstName')} ${get(
          profile,
          'data.lastName'
        )}`}
        onClose={this.closeEdit}
      >
        <MaterialModal.Content noFooter>
          <MaterialControlBar
            edit={{
              onClick: this.openEdit,
              intlKey: isEdit ? 'button.stop_editing' : 'button.edit',
              label: 'Edit'
            }}
          />
          <EditProfile
            profile={profile}
            isEdit={isEdit}
            afterEdited={this.closeEdit}
            initialValues={initialValuesEdit(get(profile, 'data'))}
            isAssessor={isAssessor}
          />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
